import "dayjs/locale/en.js";
import "dayjs/locale/fr.js";
